"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UUID = void 0;
var runtypes_1 = require("runtypes");
exports.UUID = runtypes_1.String;
//# sourceMappingURL=UUID.js.map